import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <Link to="/shop" onClick={toTop}>
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <div className="cart-page__main">
          <h1 className="cart-page__title">My Cart ({cartItems.length})</h1>

          <div className="cart-page__items">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;

              return (
                <div
                  key={`${item.id}-${item.size}-${item.color}`}
                  className="cart-item"
                >
                  <div className="cart-item__image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-item__details">
                    <div className="cart-item__header">
                      <h3 className="cart-item__name">{product.name}</h3>
                      <button
                        className="cart-item__remove"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                      >
                        ✕
                      </button>
                    </div>
                    <div className="cart-item__price">
                      <span className="cart-item__price-current">
                        €{product.price}
                      </span>
                    </div>
                    <div className="cart-item__options">
                      <Link
                        to={`/shopDetails/${item.id}`}
                        onClick={toTop}
                        className="cart-item__link"
                      >
                        Item Details
                      </Link>
                      <span className="cart-item__divider">✕</span>
                      <Link
                        to={`/shopDetails/${item.id}`}
                        onClick={toTop}
                        className="cart-item__link"
                      >
                        Modify Item
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-page__gift">
            <div className="cart-page__gift-icon">🎁</div>
            <div className="cart-page__gift-text">
              <span className="cart-page__gift-title">Is This A Gift?</span>
              <span className="cart-page__gift-link">
                Add a personalized gift packaging
              </span>
            </div>
          </div>
        </div>

        <div className="cart-page__summary">
          <div className="cart-page__summary-header">
            <Link to="/shop" onClick={toTop} className="cart-page__continue">
              Continue Shopping
            </Link>
          </div>

          <div className="cart-page__summary-content">
            <div className="cart-page__summary-title">
              <span>🛒</span> Cart Summary
            </div>

            <div className="cart-page__summary-row">
              <span className="cart-page__summary-label">Item Subtotal</span>
              <span className="cart-page__summary-value">
                €{subtotal.toFixed(2)}
              </span>
            </div>

            <div className="cart-page__summary-row">
              <span className="cart-page__summary-label">Sales Tax</span>
              <span className="cart-page__summary-value">
                Calculated at checkout
              </span>
            </div>

            <div className="cart-page__summary-total">
              <span className="cart-page__summary-label">Estimated Total</span>
              <span className="cart-page__summary-value">
                €{subtotal.toFixed(2)} EUR
              </span>
            </div>

            <button className="cart-page__checkout" onClick={handleCheckout}>
              🛒 Checkout
            </button>

            <div className="cart-page__secure">
              Review your selections and total before continuing.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
